import { InventoryProvider } from 'src/__generated__/graphqlTypes';
import { Maybe } from '../../types';

export type Permission =
  | [
      grant: 'create:rateplan' | 'delete:rateplan' | 'edit:rateplan',
      subject: {
        inventoryProvider?: InventoryProvider;
      },
    ]
  | [
      grant: 'edit:ratesAndInventory',
      subject: {
        inventoryProvider: Maybe<InventoryProvider>;
        ratesServiceEnabled: Maybe<boolean>;
      },
    ]
  | [
      grant: 'view:users',
      subject: {
        role: string;
      },
    ]
  | [
      grant: 'view:propertyGroup',
      subject: {
        role: string;
      },
    ];

function can([grant, subject]: Permission): boolean {
  switch (grant) {
    case 'create:rateplan':
    case 'delete:rateplan':
    case 'edit:rateplan': {
      return (
        Boolean(subject.inventoryProvider) &&
        subject.inventoryProvider !== InventoryProvider.Derbysoft &&
        subject.inventoryProvider !== InventoryProvider.Expedia
      );
    }

    case 'edit:ratesAndInventory': {
      return (
        subject.ratesServiceEnabled === true &&
        subject.inventoryProvider === InventoryProvider.Extranet
      );
    }

    case 'view:users': {
      return Boolean(
        subject.role === 'staff' ||
          subject.role === 'property_admin' ||
          subject.role === 'property_group_admin',
      );
    }

    case 'view:propertyGroup': {
      return Boolean(
        subject.role === 'staff' || subject.role === 'property_group_admin',
      );
    }

    default: {
      return false;
    }
  }
}

export function useConditionalDisplay() {
  return can;
}
